import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import Logo from '../assets/images/freitora_logo-wb.png';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: '', password: '' });
  const [visibility, setVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const toggleVisibility = () => setVisibility((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/staff/signin`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        login();
        toast.success('Login Successful');

        // Wait briefly before reload to ensure state is synced
        setTimeout(() => {
          navigate('/dashboard');
          window.location.reload(); // 🔄 Force refresh to reload everything cleanly
        }, 100);
      } else {
        setError(data.message || 'Login failed');
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message || 'Login error');
      setError('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="bg-primary min-h-screen pt-12 md:pt-20 pb-6 px-4">
      <main className="bg-white max-w-lg mx-auto p-8 md:p-12 my-10 rounded-lg shadow-2xl">
        <section>
          <img
            src={Logo}
            alt="Freitora Logo"
            className="w-32 m-auto"
          />

          {error && (
            <div className="text-center text-red-500 font-medium mt-4">{error}</div>
          )}

          <form
            className="flex flex-col mt-6 space-y-4"
            onSubmit={handleSubmit}
            noValidate
          >
            <div>
              <label htmlFor="email" className="block mb-1 text-gray-700">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                className="input input-bordered w-full"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label htmlFor="password" className="block mb-1 text-gray-700">
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={visibility ? 'text' : 'password'}
                  value={form.password}
                  onChange={handleChange}
                  className="input input-bordered w-full pr-10"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  onClick={toggleVisibility}
                  className="absolute right-3 top-3 text-xl text-gray-600"
                  aria-label={visibility ? 'Hide password' : 'Show password'}
                >
                  {visibility ? <MdVisibilityOff /> : <MdVisibility />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="bg-primary hover:bg-blue-800 text-white font-semibold py-2 rounded shadow-lg hover:shadow-xl transition duration-200"
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <div className="text-center mt-4">
            <Link to="/forgot-password" className="text-primary hover:underline">
              Forgot Password?
            </Link>
          </div>
        </section>
      </main>

      <footer className="max-w-lg mx-auto text-center mt-12 mb-6 text-white text-sm">
        Warehouse Management System &copy; {new Date().getFullYear()}
      </footer>
    </div>
  );
};

export default Login;
